import { Helper } from '../Helper';
export class RawEnumeratorFilterHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        const handleResult = (innerOptions) => {
            sb.emitHelper(node, innerOptions, sb.helpers.if({
                condition: () => {
                    this.each(innerOptions);
                },
                whenTrue: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'SWAP');
                    sb.emitOp(node, 'APPEND');
                },
                whenFalse: () => {
                    sb.emitOp(node, 'NIP');
                },
            }));
        };
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitHelper(node, options, sb.helpers.rawEnumeratorReduce({
            each: (innerOptions) => {
                sb.emitOp(node, 'OVER');
                handleResult(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawEnumeratorFilterHelper.js.map
